import React from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "./DashMenu.css";

const DashMenu = ({ toggleMenu, showMenu }) => {
  const onClick = () => {
    toggleMenu();
  };
  return (
    <div className="dash-menu-container">
      <div className="dash-menu" onClick={onClick}>
        <div className="dash-menu-wrapper" >
          {!showMenu ? (
            <FaTimes className="dash-bar" />
          ) : (
            <FaBars className="dash-bar" />
          )}
        </div>
        <h3>Menu</h3>
      </div>
    </div>
  );
};

export default DashMenu;
